import {Component, OnInit} from '@angular/core';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {UtilitiesService} from '../../services/utilities.service';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {
  quotes: any[];
  isBeforeCutoffDate = true;

  constructor(private realtorPortalService: RealtorPortalService) {}

  ngOnInit() {
    this.realtorPortalService.getQuotes().then(
      quotes => { this.quotes = quotes; });

    var today = new Date();
    var cutoff = new Date(2023, 1, 1);

    if (today >= cutoff)
      this.isBeforeCutoffDate = false;
  }


  get baseUrl(): string { return UtilitiesService.baseAPIUrl; }
}
